var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-tooltip',{attrs:{"content-class":"bg-yellow text-dark shadow-4","content-style":"font-family: 'Inter', sans-serif; letter-spacing: 1px;","offset":_vm.offset,"anchor":_vm.anchor,"self":_vm.self}},[_vm._v(" "+_vm._s(_vm.tooltip)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }